import axios from "axios";

export const getCatchReportNextDeadline = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/CatchReport/next-deadline`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
